import * as React from "react";
import { forwardRef } from "react";
const SvgAccept = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 11, height: 10, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#32AF04", stroke: "#32AF04", strokeWidth: 0.5, d: "M8.776 1.397 4.284 7.416 2.137 5.26a.81.81 0 0 0-1.152 0 .82.82 0 0 0 0 1.147v.002l2.81 2.822zm0 0a.813.813 0 1 1 1.299.977l-5.056 6.77zM4.371 9.47a.8.8 0 0 1-.576-.24zm0 0q.03 0 .059-.002a.81.81 0 0 0 .59-.324l-.649.326Z" }));
const ForwardRef = forwardRef(SvgAccept);
export { ForwardRef as ReactComponent };
